<template>
  <div class="autocomplete-container">
    <v-autocomplete
      v-model="innerValue"
      :error-messages="errorMessages"
      :success="showSuccess && !errorMessages.length"
      :items="items"
      :clearable="$attrs.readonly ? false : true"
      :rules="computedRules"
      v-bind="$attrs"
      v-on="$listeners"
      outlined
      :class="{
        'readonly-input': $attrs.readonly
      }"
    >
      <template
        #selection="data"
        v-if="$attrs.multiple && $attrs.customChips"
      >
        <div class="mt-2 selection-container">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click:close="$attrs.readonly ? null : remove(data.item)"
          >
            <span class="select-chip">
              {{
                typeof data.item !== 'object' ? data.item : data.item['text']
              }}
            </span>
          </v-chip>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    rules: {
      type: [Array, String],
      default: () => [],
    },
    value: {
      default: null,
    },
    items: {
      default: () => [],
    },
    showSuccess: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    computedRules() {
      const rulesArray = Array.isArray(this.rules) ? this.rules : [this.rules];
      // Add required rule if needed
      return [
        (v) => !!v || `${this.$attrs.label || 'Field'} is required`,
        ...rulesArray,
      ];
    },
    errorMessages() {
      return this.computedRules
        .map((rule) => rule(this.innerValue))
        .filter((message) => message !== true);
    },
  },
  methods: {
    remove(item) {
      let index;
      if (typeof item !== 'object') {
        index = this.value.indexOf(item);
      } else {
        index = this.value.findIndex((element) => element === item.value);
      }
      if (index !== -1) {
        this.value.splice(index, 1);
        this.innerValue = this.value;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.autocomplete-container {
  &::v-deep .v-select.v-input--dense .v-chip {
    margin: 4px;
  }
}

.selection-container {
  max-width: 100%;
}
.select-chip {
  display: inline-block !important;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
